import { ContinuumSharedApiProvider, type ContinuumSharedApi } from "@equinoxx/react";
import React from "react";
import appApi from "../../classes/appApi";
import { useApiContext } from "./AppApi";

export class AppContinuumSharedApi implements ContinuumSharedApi {
    private api: appApi
    constructor(api: appApi) {
        this.api = api
    }
    get<TResponse>(path: string): Promise<TResponse> {
        return this.api.get(path)
    }
    post<TResponse, TBody = unknown>(path: string, body?: TBody): Promise<TResponse> {
        return this.api.post(path, body)
    }
    put<TResponse, TBody = unknown>(path: string, body?: TBody): Promise<TResponse> {
        return this.api.request(path, 'put', body)
    }
    delete<TResponse, TBody = unknown>(path: string, body?: TBody): Promise<TResponse> {
        return this.api.request(path, 'delete', body)
    }
    patch<TResponse, TBody = unknown>(path: string, body?: TBody): Promise<TResponse> {
        return this.api.request(path, 'patch', body)
    }
}

export default (props: { children: React.ReactNode }) => {
    const appApi = useApiContext()
    const api = new AppContinuumSharedApi(appApi)
    return (
        <ContinuumSharedApiProvider value={api}>
            {props.children}
        </ContinuumSharedApiProvider>
    )
}
